(function () {
    'use strict';
    var controllerId = 'testAdd';
    angular.module('app').controller(controllerId, ['$scope', 'common', '$uibModalInstance', 'datacontext', 'docenti', 'docenteId', 'materie', 'materiaId', 'tipoTest', testAdd]);

    function testAdd($scope, common, $uibModalInstance, datacontext, docenti, docenteId, materie, materiaId, tipoTest) {
        $scope.test = {};
        $scope.materie = materie;
        $scope.bTitleChanged = false;
        $scope.docenti = docenti;
        $scope.docenteDisabled = false;
        $scope.tipoTest = tipoTest;

        if ($scope.materie.length == 0)
            getMaterie();

        if ($scope.docenti.length == 0)
            getDocenti();
        
        //Parametro materiaId utilizzato per impostare e bloccare selezione Materia
        //Utilizzato in caso di creazione nuovo test da view /app/materia/materiaDetail.html
        if (materiaId) {
            $scope.materiaId = materiaId;
            $scope.test.materiaId = materiaId;
        }

        if (docenteId) {
            $scope.docenteId = docenteId;
            $scope.test.docenteId = docenteId;
            $scope.docenteDisabled = true;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.test);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };        

        function addItem(item) {
            item.layout = 1;
            return datacontext.test_add(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) return null;

                return data;
            });
        }

        $scope.DocenteChanged = function () {
            if (!$scope.test.docenteId)
                return false;

            $scope.materie = getMaterieByDocente();
        };

        $scope.TitleChanged = function () {
            $scope.bTitleChanged = true;
            return false;
        };

        //getList
        function getMaterie() {
            return datacontext.materia_getAllList().then(function (data) {
                return $scope.materie = data;
            });
        }

        //Studente
        function getMaterieByDocente() {
            return datacontext.materia_getAllListByDocente($scope.test.docenteId).then(function (data) {
                return $scope.materie = data;
            });
        }

        function getDocenti() {
            return datacontext.risorsa_getAllListByStudente().then(function (data) {
                return $scope.docenti = data;
            });
        }
    }
})();